import { margin } from "@mui/system";
import { Document, Image, Page, View, Text } from "@react-pdf/renderer";
import { useEffect, useState } from "react";


const styles = {
  page: {
    backgroundColor: "#fff",
    fontFamily: "Helvetica",
    lineHeight: 1.5,
    flexDirection: "column",
  },
  image: {
    backgroundColor: "#5E17EB",
    width: "100%",
    height: "100%",
  },
  
  eventPart: {
    flexDirection: "row",
    marginTop: 15,
    marginBottom: 15,
    marginHorizontal: 20,
  },
  ticketPart: {
    flexDirection: "row",
    marginTop: 15,
    marginBottom: 15,
    marginHorizontal: 20,
  },
  ticketPart2: {
    width: "100%",
    textAlign: "center",
  },
  textEventname: {
    fontSize: 15,
    fontWeight: "heavy",
  },
  textSecondary: {
    fontSize: 10,
    fontWeight: "bold",
    color: '#bababa'
  },
  textImportant: {
    fontSize: 13,
    fontWeight: 900,
  },
  text: {
    fontSize: 22,
    fontWeight: "heavy",
  },

  textDetails: {
    fontSize: 7,
  },
  qrCodeContainer: {
    
    display:'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 20,
  
  },
  qrCode: {
    height: 300,
    width: 300,
    marginBottom: 20
  },
};

const CttDoorDoc = ({ link }) => (
    <Document>
      <Page size="A5" style={styles.page}>
        <View>
          <View style={styles.ticketPart}>
            <View style={styles.ticketPart2}>
              <View style={styles.qrCodeContainer}>
                <Image
                  style={styles.qrCode}
                  src={link}/>
                <Text break style={styles.text}>
                  Scannez pour acheter vos billets
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );

export default CttDoorDoc;